import styled from 'styled-components';

export const Div = styled.div`
    width: 100%;
`;

export const Wrapper = styled.div`
    width: 33%;
    height: ${(props) => (props.generalSetting ? '285px' : '195px')};
    position: fixed;
    top: 0px;
    left: 0px;
    border: 2px solid lightgray;
    z-index: 2;
`;

export const ElemSettingsDiv = styled(Wrapper)`
    width: 65.5%;
    right: 0;
    left: 34%;
    z-index: 2;
`;

export const ToolboxDiv = styled(Wrapper)`
    height: calc(100% - 307px);
    top: 260;
    margin-top: 297px;
    z-index: 0;

`;

export const CanvasDiv = styled.div`
    width: 65.5%;
    height: calc(100% - 219px);
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    top: 208px;
    right: 2px;
    background: ${({ theme }) => theme.colors.neutral900};
    border: 2px solid lightgray;
`;

export const PreviewDiv = styled(Wrapper)`
    width: 65.5%;
    right: 0;
    margin-left: 34%;
    z-index: 0;
`;

export const LeftBorder = styled.div`
    position: absolute;
    height: 100%;
    width: 1px;
    top: 0px;
    left: 0px;
    z-index: 1;
    background: ${(props) => (props.red ? props.theme.colors.danger300 : props.theme.colors.primary300)};
`;

export const TopBorder = styled.div`
    position: absolute;
    width: 100%;
    height: 1px;
    top: 0px;
    left: 0px;
    z-index: 0;
    background: ${({ red, theme }) => (red ? theme.colors.danger300 : theme.colors.primary300)};
`;


export const RightBorder = styled.div`
    position: absolute;
    height: 100%;
    width: 1px;
    top: 0px;
    right: 0px;
    z-index: 1;
    background: ${({ red, theme }) => (red ? theme.colors.danger300 : theme.colors.primary300)};

`;

export const BottomBorder = styled.div`
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: 0px;
    left: 0px;
    z-index: 1;
    background: ${({ red, theme }) => (red ? theme.colors.danger300 : theme.colors.primary300)};
`;

export const BlueLeftBorder = styled.div`
    background: ${({ theme }) => `repeating-linear-gradient(90deg,transparent,transparent 3px, ${theme.colors.primary300} 3px, ${theme.colors.primary300} 6px)`};
`;

export const BlueTopBorder = styled.div`
    background: ${({ theme }) => `repeating-linear-gradient(0deg,transparent,transparent 3px, ${theme.colors.primary300} 3px, ${theme.colors.primary300} 6px)`};
`;

export const BlueRightBorder = styled.div`
    background: ${({ theme }) => `repeating-linear-gradient(90deg,transparent,transparent 3px, ${theme.colors.primary300} 3px, ${theme.colors.primary300} 6px)`};
`;

export const BlueBottomBorder = styled.div`
    background: ${({ theme }) => `repeating-linear-gradient(0deg,transparent,transparent 3px, ${theme.colors.primary300} 3px, ${theme.colors.primary300} 6px)`};
`;

export const ToolbarDiv = styled.div`
    width: ${(props) => (props.leftPanelCollapsed ? 'calc((100% - 250px) - 64px)' : 'calc((100% - 250px) - 250px)')};
    position: absolute;
    top: 12px;
    right: 250px;
    height: 1px;
    margin-left: 0px;
    display: flex;
`;
